import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ReservationExtendSerializer } from "@/types/reservation"
import {
  createReservation,
  updateReservation,
  // fetchMonthlyReservations,
  reservationFetchThunk,
} from "@core/api/reservationApi"
import { clear } from "@testing-library/user-event/dist/clear"
import { applyPatientListUpdates } from "@/features/visit/patientListUpdates"

interface ReservationState {
  reservations: ReservationExtendSerializer[]
  reservation: ReservationExtendSerializer | null
  selectedReservation: ReservationExtendSerializer | null
  loading: boolean
  error: string | null
  currentRequestId: string | null
  loadedDate: string | null
  generation: number
}

const initialState: ReservationState = {
  reservations: [],
  reservation: null,
  selectedReservation: null,
  loading: false,
  error: null,
  currentRequestId: null,
  loadedDate: null,
  generation: 0,
}

const reservationSlice = createSlice({
  name: "reservation",
  initialState,
  reducers: {
    setReservations(state, action: PayloadAction<ReservationExtendSerializer[]>) {
      state.reservations = action.payload
      state.generation += 1
    },
    setReservation(state, action: PayloadAction<Partial<ReservationExtendSerializer>>) {
      const merged = {
        ...state.reservation,
        ...action.payload,
      }
      state.reservation = merged as ReservationExtendSerializer
    },
    clearReservations(state) {
      state.reservations = []
      state.loadedDate = null
      state.generation += 1
    },
    clearReservation(state) {
      state.reservation = null
    },
    selectReservation(state, action: PayloadAction<ReservationExtendSerializer | null>) {
      state.selectedReservation = action.payload
    },
    clearSelectedReservation(state) {
      state.selectedReservation = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(applyPatientListUpdates, (state, action) => {
        if (!action.payload.reservations) return
        state.reservations = action.payload.reservations
        state.loadedDate = action.payload.date
        state.loading = false
        state.error = null
        state.currentRequestId = null
        state.generation += 1
      })
      .addCase(reservationFetchThunk.pending, (state, action) => {
        state.generation += 1
        state.loading = state.loadedDate !== (action.meta.arg || "")
        state.error = null
        state.currentRequestId = action.meta.requestId
      })
      .addCase(reservationFetchThunk.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) {
          return
        }
        state.loading = false
        state.reservations = action.payload
        state.loadedDate = action.meta.arg || ""
        state.currentRequestId = null
      })
      .addCase(reservationFetchThunk.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) {
          return
        }
        state.loading = false
        state.error = action.payload ?? "예약 목록 조회 실패"
        state.currentRequestId = null
      })
    // .addCase(fetchMonthlyReservations.pending, (state) => {
    //   state.loading = true
    //   state.error = null
    // })
    // .addCase(fetchMonthlyReservations.fulfilled, (state, action) => {
    //   state.loading = false
    //   state.reservations = action.payload
    // })
    // .addCase(fetchMonthlyReservations.rejected, (state, action) => {
    //   state.loading = false
    //   state.error = action.payload ?? "예약 목록 조회 실패"
    // })
  },
})

export const {
  setReservations,
  setReservation,
  clearReservations,
  clearReservation,
  selectReservation,
  clearSelectedReservation,
  setLoading,
  setError,
} = reservationSlice.actions

export default reservationSlice.reducer
